require('./menu');
require('./filters');
require('./purchase-process');
require('./gallery');
require('./features-list');
require('./tweaks');
require('./ratings');
require('./locking');
require('./fluent');
require('./extras');
require('./print');